import { literal, object, optional, type InferOutput } from "valibot"
import { InputBindingDevice } from "../InputBindingDevice.enum"
import { MouseButtonSchema } from "../MouseButton.enum"

export const MouseClickInputBindingSchema = object({
  device: literal(InputBindingDevice.Mouse),
  click: optional(literal(true)),
  button: MouseButtonSchema,
})

export type MouseClickInputBinding = InferOutput<typeof MouseClickInputBindingSchema>